(() => {
  function init(root = document) {
    root.querySelectorAll('[data-cn-cover-rotation]').forEach(section => {
      if (section.dataset.coverReady) return;
      section.dataset.coverReady = 'true';
      const covers = [...section.querySelectorAll('.cn-card-media--rotation')];
      const button = section.querySelector('[data-cn-cover-toggle]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = motion.matches;
      let secondary = false;
      let visible = false;
      const observer = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
      });
      observer.observe(section.querySelector('.cn-grid'));
      function updateButton() {
        button.hidden = false;
        button.textContent = paused ? 'Avvia immagini' : 'Pausa immagini';
        button.setAttribute('aria-pressed', String(paused));
      }
      button.addEventListener('click', () => { paused = !paused; updateButton(); });
      motion.addEventListener('change', event => { paused = event.matches; updateButton(); });
      updateButton();
      const timer = window.setInterval(() => {
        if (!section.isConnected) { window.clearInterval(timer); observer.disconnect(); return; }
        if (paused || !visible || document.hidden) return;
        if (!covers.every(cover => [...cover.querySelectorAll('img')].every(image => image.complete && image.naturalWidth))) return;
        secondary = !secondary;
        covers.forEach(cover => cover.classList.toggle('is-secondary', secondary));
      }, 4500);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
